import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Category } from 'src/app/models/category/categoryListing.modal';
import { ProductSort, ProductTypeModel } from 'src/app/models/Home/home-list.model';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { CategoryService } from 'src/app/services/category.service';
import { HomePageService } from 'src/app/services/home-page.service';
import { IsjustAddedService } from 'src/app/services/isjust-added.service';
import { ResetSidebarService } from 'src/app/services/reset-sidebar.service';
import { HomePageComponent } from '../home-page/home-page.component';

@Component({
  selector: 'app-shop-sidebar',
  templateUrl: './shop-sidebar.component.html',
  styleUrls: ['./shop-sidebar.component.css']
})
export class ShopSidebarComponent implements OnInit {

  categoryResonseFullList: Array<Category> = new Array<Category>();
  categoryList: Array<Category> = new Array<Category>();
  selectedCategotyIds: Array<string> = new Array<string>();
  Loader: boolean = false;
  productName: string;
  homeContentList: ProductSort = new ProductSort();
  totalPages: number;
  IsJustAdded  : boolean;
  toggle = true;
  resetNewToggle = true;
  resetUsedToggle = true;
  selectedjust: string;
  selectedProductType: Array<string> = new Array<string>();
  selectedProduct: Array<ProductTypeModel> = new Array<ProductTypeModel>();
  productType : ProductTypeModel;
  newToggle : boolean = false;
  usedToggle: boolean = false;
  useToggle : boolean = false;
  pagingModel: PagingModel = new PagingModel();
  
  constructor(private _isJustAddedService:IsjustAddedService, private router: Router, private _homePageService: HomePageService,  private _categoryService: CategoryService, private homePageService: HomePageService, private resetSidebarService: ResetSidebarService, private component: HomePageComponent, private route: ActivatedRoute) { }

  ngOnInit() {
    this.homePageService.productCondition.subscribe((productCondition: string) => {    
      if (productCondition) {
          this.selectProductType(Number.parseInt(productCondition));
      }
    }); 

    this.resetSidebarService.resetStatus.subscribe((status: string) => {
      if(status == 'true'){
        this.resetCategories();
      }
    });


    this.resetSidebarService.resetStatus.subscribe((justAdded: string) => {
      if(justAdded == 'true'){
        this.resetJustAdded();
      }
    });
    this.resetSidebarService.resetStatus.subscribe((newProduct: any) => {
      if(newProduct == "true"){
         this.resetProductType();
      }
    });

    this.resetSidebarService.resetStatus.subscribe((refurbished: string) => {
      if(refurbished =="true"){
         this.resetProductType();
      }
    });
    this.addCategory();
  }

  addCategory() {
    this.Loader = true;
    this._categoryService.leftCategoryMenu()
      .subscribe((response) => {
        this.Loader = false
        let categoryLeftMenu = JSON.parse(response._body);
        if (categoryLeftMenu.isSuccess) {
          this.categoryResonseFullList = categoryLeftMenu.responseData;
          for(var i = 0; i < categoryLeftMenu.responseData.length; i++)
          {
            var category = categoryLeftMenu.responseData[i];
            var categoryObj = new Category();
            categoryObj.categoryName = category.categoryName;
            categoryObj.id = category.id;
            categoryObj.isSelected = false;
            this.categoryList.push(categoryObj);
          }
         
        } (err) => {
          this.Loader = false;
        }
      });
  }

  selectCategory(category:Category) { 
    category.isSelected = !category.isSelected;
    if(category.isSelected) {
      this.selectedCategotyIds.push(category.id.toString())
    } else {
      this.selectedCategotyIds.forEach((element,index)=>{
        if(element == category.id.toString()) this.selectedCategotyIds.splice(index,1);
     });
    }   
    var selectCategories = "";
    if (this.selectedCategotyIds.length > 0) {
      selectCategories = this.selectedCategotyIds.join(",");
    }
    this.homePageService.passCategoryId(selectCategories);
    this.pagingModel.pageNumber = 1;
    this.pagingModel.pageSize = 10;
    this.component.loadPage(this.pagingModel);
  }

  searchCatergoryMenu(searchKeyword: string) {
    this.categoryList = this.categoryResonseFullList.filter((category: Category) => { 
      if (category.categoryName.toLowerCase().includes(searchKeyword.toLowerCase())) {
        return category;
      }
    });
  }

  resetCategories(){
    this.categoryList.forEach(category => {
      category.isSelected = false;
    });
    this.selectedCategotyIds = [];
  }

  resetJustAdded() {
    if (this.toggle == false) {
      this.toggle = !this.toggle;;
    }
    this._isJustAddedService.isJustAdded = false;
  }
  
  justAdded() {
    this.toggle = !this.toggle;
    var isJustAdded = this._isJustAddedService.isJustAdded;
    if (isJustAdded == true) {
      this._isJustAddedService.isJustAdded = false;
    } else {
      this._isJustAddedService.isJustAdded = true;
    }
    this.component.HomeProductList();
    this.pagingModel.pageNumber = 1;
    this.pagingModel.pageSize = 10;
    this.component.loadPage(this.pagingModel);
    
  }

  selectProductType(productType) {
    if (this.selectedProductType.includes(productType)) {
      var index = this.selectedProductType.filter(x => productType != x);
      if (index.length != 0) {
        if (productType == 2) {
          this.newToggle = false;
        } else if(productType == 3) 
        {
          this.usedToggle = true;
        }
        else {
          this.useToggle = false;
        }
        this.selectedProductType = index;
      } else {
        this.selectedProductType = [];
        this.newToggle = false;
        this.useToggle = false;
        this.usedToggle = false;
      }
    }
    else {
      if (productType == 2) {
        this.newToggle = true;
      } else if(productType == 3) {
        this.usedToggle = true;
      } else {
        this.useToggle = true;
      }
      this.selectedProductType.push(productType);
    }
    var selectProductType = "";
    if (this.selectedProductType.length > 0) {
      selectProductType = this.selectedProductType.join(",");
    }
    this.homePageService.passProductType(selectProductType);
    this.pagingModel.pageNumber = 1;
    this.pagingModel.pageSize = 10;
    this.component.loadPage(this.pagingModel);
  }


  resetProductType() {
    this.selectedProduct.forEach(type => {
      type.newToggle = false;
    });
    this.selectedProductType = [];
    this.newToggle = false;
    this.useToggle = false;
    this.usedToggle = false;
  }
  }


